export class BNLImage {
	init() {
		const fallbackImages = document.querySelectorAll("img[data-fallbacksrc]");
		fallbackImages.forEach(fallbackImage => {
			fallbackImage.addEventListener("error", () => {
				const fallbackSrc = fallbackImage.getAttribute("data-fallbacksrc");

				if (fallbackSrc) {
					fallbackImage.setAttribute("src", fallbackSrc);
				}
			});
		});
	}
}

(() => {
	const accordian = new BNLImage();
	accordian.init();
})();
